import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import ReviewsContent from 'app/pageContents/ReviewsContent';
import { configureReviewPageHead } from 'app/utils/configurePageHead';
import { getReviewPageProps } from 'app/selectors/productSelector';
import {
  getProducts,
  getProductCategories,
} from 'app/dispatcher/productDispatcher';
import dispatchWithPromise from 'app/utils/withPromise';

const overrideWrapperStyles = {
  justifyContent: 'stretch',
  flexDirection: 'column',
};

const Reviews = () => {
  const reviewHeaderProps = useSelector(getReviewPageProps, shallowEqual);

  return (
    <Page pageContentStyle={overrideWrapperStyles}>
      <PageHead {...configureReviewPageHead(reviewHeaderProps.seoMeta)} />
      <ReviewsContent />
    </Page>
  );
};

Reviews.getInitialProps = async ({ store, query }) => {
  const { dispatch } = store;
  await Promise.all([
    dispatchWithPromise(dispatch, getProductCategories),
    dispatchWithPromise(dispatch, getProducts, query),
  ]);
  return {};
};

export default Reviews;
